import { objectWithoutProperties as _objectWithoutProperties, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useCallback } from 'react';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';
import { useContextSelector } from 'use-context-selector';
import { useSnackbar } from '@bucketplace/design-system';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../../contexts/internal/EditorContext.js';
import { useImageMapShareContext } from '../../../contexts/external/ImageMapShareContext.js';
import { useEditorInfoContext } from '../../../contexts/external/EditorInfoContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../../components/FormContent.js';

var _excluded = ["children"];
function ImageMapShareButton(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(ShareButton, props, children || jsx(EditorPlaceholder, {
    icon: jsx(BsLink45Deg, null),
    message: "\uC544\uC774\uD15C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
  }));
}
function ShareButton(_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style,
    platform = _ref2.platform,
    logData = _ref2.logData;
  var _useSnackbar = useSnackbar(),
    open = _useSnackbar.open;
  var _useImageMapShareCont = useImageMapShareContext(),
    kakaoApi = _useImageMapShareCont.kakaoApi,
    kakaoTemplateId = _useImageMapShareCont.kakaoTemplateId,
    templateArgs = _useImageMapShareCont.templateArgs,
    onClick = _useImageMapShareCont.onClick;
  var _useEditorInfoContext = useEditorInfoContext(),
    onSendLog = _useEditorInfoContext.onSendLog;
  var _useContextSelector = useContextSelector(EditorContext, function (context) {
      return context.state;
    }),
    displayMode = _useContextSelector.displayMode;
  var handleClick = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            if (!(displayMode === 'edit')) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (logData) {
              onSendLog === null || onSendLog === void 0 || onSendLog(logData);
            }
            if (platform === 'kakaotalk' && kakaoApi != null) {
              try {
                kakaoApi.Share.sendCustom({
                  templateId: kakaoTemplateId,
                  templateArgs: templateArgs,
                  installTalk: true
                });
              } catch (err) {
                console.error(err);
                open({
                  content: '카카오톡 공유에 실패했습니다.'
                });
              }
            } else {
              onClick === null || onClick === void 0 || onClick();
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [platform, displayMode, kakaoApi, open]);
  return jsx("button", {
    type: "button",
    onClick: handleClick,
    className: className,
    style: style
  }, children);
}

export { ImageMapShareButton };
//# sourceMappingURL=ImageMapShareButton.js.map
